import {getNoUndefValuesObject, getDefaultValuesObject, getStringValuesObject} from './object';
import {getSearchFilters} from './search';
import {getFormattedDate, getNightsCount, hasFilledDatesValues} from './dates';

const DEFAULT_EVENT_FIELD_VALUE = '-1';

function triggerGenericEdapEvent(trackingContext, data, options = {}) {
    function getEventFields() {
        const {
            actionLocation,
            eventAction,
            eventCategory,
            eventLabel,
            eventRequestMarker,
            eventValue,
            highFrequency
        } = data;

        let eventFields = {
            eventaction: eventAction,
            eventcategory: eventCategory,
            ...getNoUndefValuesObject({
                actionlocation: actionLocation,
                eventlabel: eventLabel,
                eventrequestmarker: eventRequestMarker,
                eventvalue: eventValue,
                highfrequency: highFrequency
            })
        };

        eventFields = getStringValuesObject(getDefaultValuesObject(eventFields, DEFAULT_EVENT_FIELD_VALUE));

        return eventFields;
    }

    function getEventOptions() {
        const {
            forceData,
            maxWaitTime,
            playbackObj
        } = options;

        return getNoUndefValuesObject({
            forceData,
            maxWaitTime,
            playbackObj
        });
    }

    const eventName = 'generic.event';
    const eventFields = getEventFields();
    const eventOptions = getEventOptions();

    function isEventValid() {
        const {
            eventaction: eventAction,
            eventcategory: eventCategory
        } = eventFields;

        return (
            eventAction !== DEFAULT_EVENT_FIELD_VALUE &&
            eventCategory !== DEFAULT_EVENT_FIELD_VALUE
        );
    }

    /* istanbul ignore else */
    if (isEventValid()) {
        trackingContext.trigger(eventName, eventFields, eventOptions);
    }
}

function triggerDestinationEmptySearchErrorEdapEvent(trackingContext) {
    triggerGenericEdapEvent(trackingContext, {
        actionLocation: 'search-widget',
        eventAction: 'empty destination error',
        eventCategory: 'search button'
    });
}

function triggerDestinationSummaryClickEdapEvent(trackingContext, edapOptions) {
    const {
        destinationSummaryClickEventAction,
        destinationSummaryClickEventCategory
    } = edapOptions;

    triggerGenericEdapEvent(trackingContext, {
        eventAction: destinationSummaryClickEventAction,
        eventCategory: destinationSummaryClickEventCategory
    });
}

function triggerSubmitSummaryClickEdapEvent(trackingContext, edapOptions) {
    const {
        submitSummaryClickEventAction,
        submitSummaryClickEventCategory
    } = edapOptions;

    triggerGenericEdapEvent(trackingContext, {
        eventAction: submitSummaryClickEventAction,
        eventCategory: submitSummaryClickEventCategory
    });
}

function triggerDetailsModalCloseEdapEvent(trackingContext, edapOptions) {
    const {
        detailsModalCloseEventAction,
        detailsModalCloseEventCategory
    } = edapOptions;

    triggerGenericEdapEvent(trackingContext, {
        eventAction: detailsModalCloseEventAction,
        eventCategory: detailsModalCloseEventCategory
    });
}

function triggerSearchQuerySubmittedEdapEvent(trackingContext, edapOptions) {
    const {
        searchQuerySubmittedEventName: eventName
    } = edapOptions;

    trackingContext.trigger(eventName);
}

function triggerSearchSubmitEdapEvent(trackingContext, edapOptions, latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues) {
    const {
        searchSubmitEventName,
        datedSearchSubmitEventName
    } = edapOptions;

    const {
        startDate,
        endDate
    } = latestDatesValues;

    const {
        adultsCount,
        childrenCount,
        bedroomsCount,
        petIncluded
    } = latestGuestsValues;

    const isDatedSearch = hasFilledDatesValues(latestDatesValues);

    function getEventName() {
        return isDatedSearch ? datedSearchSubmitEventName : searchSubmitEventName;
    }

    function getEventFields() {
        let nightsCount;

        let eventFields = {
            ...getNoUndefValuesObject({
                numadults: adultsCount,
                numchildren: childrenCount,
                numbedrooms: bedroomsCount,
                withpets: petIncluded
            })
        };

        if (isDatedSearch) {
            nightsCount = getNightsCount(startDate, endDate);

            eventFields = {
                ...eventFields,
                startdate: startDate,
                enddate: endDate,
                ...getNoUndefValuesObject({
                    lengthofstay: nightsCount
                })
            };
        }

        function getEventRefinements() {
            const sleepsCount = adultsCount + childrenCount;

            const adultsRefinement = `adults_${adultsCount}`;
            const childrenRefinement = `children_${childrenCount}`;
            const sleepsRefinement = `sleeps_${sleepsCount}`;
            const bedroomsRefinement = `bedrooms_${bedroomsCount}`;
            const petsRefinement = `pets_${petIncluded}`;

            let eventRefinements = [
                adultsRefinement,
                childrenRefinement,
                sleepsRefinement,
                bedroomsRefinement,
                petsRefinement
            ];

            if (isDatedSearch) {
                const currentDate = getFormattedDate(new Date());
                const windowCount = getNightsCount(currentDate, startDate);

                const nightsRefinement = `nights_${nightsCount}`;
                const windowRefinement = `window_${windowCount}`;

                eventRefinements = [
                    ...eventRefinements,
                    nightsRefinement,
                    windowRefinement
                ];
            }

            const searchFilters = getSearchFilters(latestSearchValues, latestDestinationValues);

            eventRefinements = [
                ...eventRefinements,
                ...searchFilters
            ];

            eventRefinements = eventRefinements.join(',');

            return eventRefinements;
        }

        const eventRefinements = getEventRefinements();

        eventFields = {
            ...eventFields,
            ...getNoUndefValuesObject({
                eventrefinements: eventRefinements
            })
        };

        eventFields = getStringValuesObject(getDefaultValuesObject(eventFields, DEFAULT_EVENT_FIELD_VALUE));

        return eventFields;
    }

    const eventName = getEventName();
    const eventFields = getEventFields();

    trackingContext.trigger(eventName, eventFields);
}

export {
    triggerGenericEdapEvent,
    triggerDestinationEmptySearchErrorEdapEvent,
    triggerDestinationSummaryClickEdapEvent,
    triggerSubmitSummaryClickEdapEvent,
    triggerDetailsModalCloseEdapEvent,
    triggerSearchQuerySubmittedEdapEvent,
    triggerSearchSubmitEdapEvent
};
